// Status sub-filter options for the On Hold tab. Extracted from the orders filter row (now toolbar/toolbarConfig)
// so the option set is unit-testable. key = API sub-tab value passed to
// selectStatus(); badgeColorKey = STATUS_HSL key (underscore form, bridged to
// hyphen); labelKey = i18n key resolved via t().
export type StatusFilterOption = { key: string; badgeColorKey: string; labelKey: string };

export const ON_HOLD_FILTER_OPTIONS: StatusFilterOption[] = [
  { key: 'on-hold', badgeColorKey: 'on_hold', labelKey: 'on_hold' },
  { key: 'exception', badgeColorKey: 'exception', labelKey: 'exceptions' },
];
